import { apiDelete, apiGet, apiPost } from '@/features/shared/utils/dataFetching'
import { API_URL } from '@/features/shared/utils/dataFetching/apiUrl'
import { type ValidAddress } from '@/features/account/services/Addresses/types'
import { type GuestUserParams } from '@/features/account/services/GuestUser/types'

export const fetchGuestParams = () =>
  apiGet<GuestUserParams>({
    config: { url: '/guest' },
    options: { apiUrl: API_URL.SELF_API },
    fetcherName: 'fetchGuestParams',
  })

export const postGuestCookies = (data: { address: ValidAddress }) =>
  apiPost<GuestUserParams>({
    config: { url: '/guest', data },
    options: { apiUrl: API_URL.SELF_API },
    fetcherName: 'postGuestCookies',
  })

export const deleteGuestCookies = () =>
  apiDelete<GuestUserParams>({
    config: { url: '/guest' },
    options: { apiUrl: API_URL.SELF_API },
    fetcherName: 'deleteGuestCookies',
  })
